import React from "react";
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import {formatDinero} from "./../../../utils/formatDinero";
import { useDispatch } from "react-redux";
import { eliminarHabitacionesPaqueteAction, obtenerHabitacionesByIdPaqueteAction } from "../../../ducks/habitacionDuck";
import Swal from "sweetalert2";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 250,
  },
})
const TablaRegistro = (props) => {
  const { rows = [], idPaquete =  0 } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const onDelete = (row) =>{
    DialogMessage.fire({
      title: '¿Estas seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '¡Eliminarlo!',
      cancelButtonText: '¡Cancelar!',
      reverseButtons: true
    }).then((result) =>{
      if (result.isConfirmed) {
        dispatch(eliminarHabitacionesPaqueteAction(idPaquete, row.TipoPlaza.IdTipoPlaza)).then(Response =>{
          dispatch(obtenerHabitacionesByIdPaqueteAction(idPaquete));
          ToastMessage.fire(
            '¡Elimminado!',
            '¡La habitacion ha sido eliminada!',
            'success'
          )
        })
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        ToastMessage.fire(
          'Cancelado',
          'No se ha realizado ningun cambio',
          'info'
        )
      }
    })
  }
  return (
    <TableContainer component={Paper}  className={classes.container}>
      <Table size="small" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Habitacion</TableCell>
            <TableCell align="center">Suplemento</TableCell>
            <TableCell align="center">Diponibilidad</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index+1}>
              <TableCell align="center">{`${row.TipoPlaza.Descripcion} - ${row.TipoPlaza.Personas} huésped`}</TableCell>
              <TableCell align="center">{formatDinero(row.Suplemento)}</TableCell>
              <TableCell align="center">{row.Disponibilidad}</TableCell>
              <TableCell align="center">
                <ButtonGroup
                  color="primary"
                  size="small"
                  aria-label="small outlined  button group"
                >
                  <Button onClick={() => onDelete(row)}>Eliminar</Button>
                </ButtonGroup>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default TablaRegistro;
